import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  moreTo: string;
  moreLabel?: string;
}

export default function MovieSection({
  title,
  subtitle,
  movies,
  moreTo,
  moreLabel = "查看更多",
}: MovieSectionProps) {
  return (
    <section className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="h-5 w-1.5 rounded-full bg-accent-500 md:h-6"></span>
            {title}
          </h2>
          {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
        </div>
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-accent-500"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5 lg:grid-cols-6">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}